import {Pipe, PipeTransform} from '@angular/core';

export interface AnschriftAdress {
  name: string;
  person?: string;
  strasse: string;
  plz: string;
  ort: string;
}

@Pipe({
  name: 'formatAnschriftAdress'
})
export class FormatAnschriftAdressPipe implements PipeTransform {

  constructor() {
  }

  private notEmpty = val => val;

  transform(adress: AnschriftAdress): string {
    let value = "";

    const separator = " ";
    const newLine = "\n";

    if (adress) {
      const ort = [adress.plz, adress.ort].filter(this.notEmpty).join(separator);
      value = [adress.name, adress.person, adress.strasse, ort].filter(this.notEmpty).join(newLine);
    }
    return value;
  }
}
